import React from "react";
import { useAuthDataContext } from "../../components/auth-provider";
import { Button } from "@material-ui/core";
import { AcceptInviteForm } from "../invites/AcceptInviteForm";

export const NoTenantPage = () => {
  const { user, onLogout } = useAuthDataContext();

  return (
    <div>
      <div style={{ textAlign: "justify", padding: "20px" }}>
        <h2>Olá {user?.name}</h2>

        <p>
          Este usuário ({user?.email}) ainda não esta associado a nenhum
          estabelecimento. Mas não se preocupe!
        </p>
        <p>
          Para que você consiga utilizar este aplicativo é necessário que já
          possua os sistemas da Softplus Informática
        </p>
        <p>
          Se você não é cliente entre em contato com a gente e adquirida já seu
          sistema!
        </p>
        <p>
          Se você já é cliente <b>e deseja associar este usuário</b> ao seu
          estabelecimento,{" "}
          <b>
            efetue login ou registre-se com o email autorizado durante a
            aquisição do APC Mobile.
          </b>
        </p>

        <AcceptInviteForm/>

        <p>Agradecemos sua atenção!</p>
        <Button
          type="button"
          onClick={onLogout}
          fullWidth
          variant="contained"
          color="primary"
        >
          Ok. Quero relogar agora!
          </Button>
      </div>
    </div>
  );
};
